module.exports = __webpack_public_path__ + "img/26.be100d89.gif";